module.exports = __webpack_public_path__ + "img/k1.0763ccf1.png";